import React from "react";
import { useTable } from "../../Components/useTable";

const DonationLog = () => {
  const type = "Donation Log";
  const limitPerpage = 100;
  const pageRowslinit = [20 , 50 , 100];
  const headCells = [
    { id: "diamond", numeric: false, label: "Diamond" },
    { id: "quantity", numeric: false, label: "Quality" },
    { id: "totalDiamond", numeric: false, label: "Total Diamond" },
    { id: "liveStreamId", numeric: false, label: "Live Stream ID" },
    { id: "rcoin", numeric: false, label: "RCoin" },
    { id: "totalRcoin", numeric: false, label: "Total Rcoin" },
    { id: "isPk", numeric: false, label: "Pk" },
    { id: "type", numeric: false, label: "Type" },
    { id: "created", numeric: false, label: "Created" },
    { id: "updated", numeric: false, label: "Updated" },
    { id: "targetusercode", numeric: false, label: "User Code" },
    { id: "targetusername", numeric: false, label: "User Name" },
    { id: "photoUrl", numeric: false, label: "Picture" },
    { id: "fromusername", numeric: false, label: "User Name" },
    { id: "fromusercode", numeric: false, label: "FromUser Code" },
    { id: "pictureUrl", numeric: false, label: "User Picture" },
    { id: "picture", numeric: false, label: "Gift Picture" },
    { id: "giftname", numeric: false, label: "Gift Name" },
    { id: "giftdiamond", numeric: false, label: "Gift Diamond" },
    { id: "gifttype", numeric: false, label: "Gift Type" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });

    
  return (
   <div className="admin-body">
        <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default DonationLog;
